import type { DatabaseFieldType } from '@databases/types/database';
import { DatabaseFilterType } from '@databases/types/database/view';

import type { FieldType } from '../field-types';

const checkboxFieldType: FieldType<DatabaseFieldType.CHECKBOX> = {
  supportedFilterTypes: [DatabaseFilterType.EQUALS],
  isCsvImportSupported: true,
  renderExportView: ({ value }) => (value ? '☑' : '☐'),
  parseFromHtml: (el) => {
    const textContent = el.text();
    return textContent === '☑';
  },
  getInitialValue: () => false,
  isEmptyValue: () => false, // a checkbox is never empty. there is no way to differentiate between an untouched checkbox or one unchecked.
  isEqualValue: ({ value: value1 }, { value: value2 }) => value1 === value2,
  getStringRepresentation: ({ value }) => `${value}`,
  convertFromCsv: (context) => context.value.plain.toLowerCase() === 'true'
};
export default checkboxFieldType;
